import type { OutlookDraftResponse } from "./API";

export const openOutlookDraft = async (
  draftResponse?: OutlookDraftResponse | null,
) => {
  const downloadUrl = draftResponse?.emlDownloadUrl;
  if (!downloadUrl) {
    throw new Error("Email file URL was not returned");
  }

  const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
  const fullUrl = `${baseUrl}${downloadUrl}`;

  const token = localStorage.getItem("token");
  const response = await fetch(fullUrl, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    throw new Error(`Failed to download EML file (${response.status})`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = "outlook-draft.eml";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
};
